<script setup lang="ts">
import { ref } from 'vue';
import { CookieRestClient } from '@idem/common/rest/cookie-rest-client';
import { textosSecciones as textos } from '@frontend/secciones/textos';

const props = defineProps<{ seccion: { id: string; nombre: string } }>();
const emit = defineEmits<{ renombrada: [] }>();

const rest = new CookieRestClient();
const editando = ref(false);
const nombreNuevo = ref('');
const aviso = ref('');

function editar() {
  nombreNuevo.value = props.seccion.nombre;
  aviso.value = '';
  editando.value = true;
}

async function guardar() {
  try {
    await rest.put(`secciones/${props.seccion.id}/nombre`, { nombre: nombreNuevo.value });
  } catch (error: any) {
    if (error?.response?.status !== 409) throw error;
    aviso.value = textos.nombreEnUso;
    return;
  }
  editando.value = false;
  emit('renombrada');
}
</script>

<template>
  <div v-if="editando">
    <div class="flex flex-wrap items-center gap-2">
      <input v-model="nombreNuevo" data-testid="nombre-nuevo" class="rounded border px-3 py-1" />
      <button
        data-testid="guardar-nombre"
        :disabled="!nombreNuevo"
        class="rounded-md bg-blue-600 px-3 py-1 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
        @click="guardar"
      >
        {{ textos.guardarNombre }}
      </button>
      <button data-testid="cancelar-nombre" class="text-sm text-gray-600 hover:underline" @click="editando = false">
        {{ textos.cancelar }}
      </button>
    </div>
    <p v-if="aviso" data-testid="aviso-renombrar" class="mt-1 text-sm text-red-600">{{ aviso }}</p>
  </div>
  <div v-else class="flex items-center gap-2">
    <h2 data-testid="nombre" class="text-xl font-semibold">{{ seccion.nombre }}</h2>
    <button data-testid="editar-nombre" class="text-sm text-blue-600 hover:underline" @click="editar">
      {{ textos.editarNombre }}
    </button>
  </div>
</template>
